<!--
  navItem "Provisionsereignisse" — the two-level event family of this provision type
  (04-frontend.md §6, entries 4 and 4a; AX-13 = A).

  Left:  the provision events of this provision type (selectable). cp.ProvisionTypeContractEvent
         owns exactly one configuration child, so the selectable parent pattern is the prescribed
         form here.
  Right: level 2, built ONLY once an event is selected — the price reasons
         (cp.ProvisionTypeContractEventPriceReason) that let a contract price time slice trigger
         that event. A CONTRACT_START event never reads a price reason (§6 form rules of K-15), so
         it gets the explanation instead of an empty table.

  Same shape as the sibling navItem "Matrizen" (cp-provision-type-matrix.component.html), so both
  two-level points of the object page behave alike.
-->
<div class="cp-provision-type-contract-event">

    @if (initialized && eventWidget) {
        <div class="grid m-0">

            <div class="col-12 md:col-4 p-2 pt-0">
                <mvs-widget
                        [widgetData]="eventWidget"
                        [importObjectContext]="eventImportContext"
                        (onObjectSelect)="onEventSelect($event)"
                        (onObjectDeselect)="onEventDeselect()">
                </mvs-widget>
            </div>

            <div class="col-12 md:col-8 p-2 pt-0">

                @if (priceReasonWidget) {
                    <mvs-widget
                            [widgetData]="priceReasonWidget"
                            [importObjectContext]="priceReasonImportContext">
                    </mvs-widget>
                } @else if (selectedEventId && selectedDeterminationType === cContractStart) {
                    <p-message
                            severity="info"
                            text="Dieses Ereignis wird zum Vertragsbeginn ermittelt und liest keine Preisgründe. Preisgründe werden nur für Ereignisse der Ermittlungsart „Preisänderung“ gepflegt."
                            styleClass="w-full">
                    </p-message>
                } @else {
                    <p-message
                            severity="info"
                            text="Bitte ein Provisionsereignis auswählen."
                            styleClass="w-full">
                    </p-message>
                }

            </div>

        </div>
    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
